import React,{ useState } from 'react';
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import '../css/services.css';

// IMPORTANT: Replace 'YOUR_EMBEDDED_GOOGLE_FORM_URL_HERE' with the actual
// 'embed' link you get when sharing your Google Form.
// The link typically looks like: https://docs.google.com/forms/d/e/FORM_ID/viewform?embedded=true
const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSenkKsiF2VCs6a5tDCeiy8Un60aM8G6ON1_UDjEATeqqpmSmQ/viewform?usp=dialog"; 

const ServicesPage = () => {

    const [currentQuote, setCurrentQuote] = useState(
        "\"Quote example from Bhakti Tirtha Swami. This will rotate monthly or bimonthly.\" - Bhakti Tirtha Swami"
    );
    
    return (
        <>
            <Navbar />
            <PageHeader title="Our Services" path="/services" name="Services" />
            <div className="services-container">
                <div className="container">
                    <h1 className="services-heading">Inquire About Our Services</h1>
                    <p className="services-intro">
                        Please use the form below to share your details and specific service requirements. A member of our team will get back to you shortly.
                    </p>
                    
                    {/* The Google Form is embedded here */}
                    <div className="google-form-embed">
                        <iframe 
                            src={GOOGLE_FORM_URL} 
                            width="100%" 
                            height="1000" 
                            frameBorder="0" 
                            marginHeight="0" 
                            marginWidth="0"
                            title="Service Inquiry Form"
                        >
                            Loading…
                        </iframe>
                    </div>
                </div>
            </div>
            <Footer />
            <BackToTop />
        </>
    );
}

export default ServicesPage;